import {
    SET_MARKET_BY_REGION
} from './MarketByRegionType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_MARKET_BY_REGION) {
        return {
            ...state,
            marketByRegionDropDownList: action.marketByRegionDropDownList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}